document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".cog-credits");
    const toggle = element.querySelector(".cog-credits__toggle");
    if (element && toggle) {
        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            element.classList.toggle("active");
        });
    }
});
